import React, { useEffect, useState } from "react";
import "../style.css";
import { Link } from "react-router-dom";
import Axios from "axios";

export default function WorkDb() {
  const [worklist, setWork] = useState([]);

  useEffect(() => {
    const fetchWorks = async () => {
      try {
        const response = await Axios.get(
          `https://bontech2-9d1867c52a6d.herokuapp.com/readworks/`
        );
        console.log(response);
        setWork(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchWorks();
  }, []);

  return (
    <div className="body--text--work--grid">
      <div className="front--blog--card">
        {worklist.map((val, key) => (
          <div className="work--preview" key={key}>
            <Link to={`/matters/${val.id_works}`}>
              <h3>{val.matter_title}</h3>
              <h2>Client: {val.bon_client}</h2>
              <h6>Tags: {val.work_tag}</h6>
              <h4>{val.work_text}</h4>
              <h5>{val.post_fulltext}</h5>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
